/**
 * ERP 배너 컴포넌트
 * @returns JSX.Element
 */
const ServiceBanner = () => {
	return (
		<section className="main-service main-section">
			<div className="main-service-inner">
				<div className="title-group">
					<p className="sub">All-in-One Business Platform</p>
					<strong className="title">
						꼭 필요한 정보만 간편하게, <br />
						스텔라의 경영정보 제공서비스
					</strong>
					<p className="desc">
						스타트업 경영진을 위해, ERP의 사용하지 않는 불필요한 기능은 제거하고 경영관리에 꼭 필요한 정보만 편집하여
						실시간으로 제공합니다. <br />
						ERP 이용자를 위하여는 ERP의 모든 기능 활용이 가능하고, 조직 규모에 따른 권한 설정기능을 이용하여 민감한
						정보를 관리할 수 있습니다.
					</p>
				</div>
				<div className="service-group">
					<ul className="service-list">
						<li className="service-item">
							<div className="title-group">
								<strong className="title">경영진</strong>
							</div>
							<ul className="desc-group">
								<li>
									<p className="desc">계좌잔액, 가용자금 확인</p>
								</li>
								<li>
									<p className="desc">월별 계좌 변동내역</p>
								</li>
								<li>
									<p className="desc">월별 카드 사용내역, 세금계산서 매출·매입 내역</p>
								</li>
								<li>
									<p className="desc">주요 지출내역에 대한 Memo 기능</p>
								</li>
								<li>
									<p className="desc">자금 이체 승인</p>
								</li>
							</ul>
						</li>
						<li className="service-item">
							<div className="title-group">
								<strong className="title">경영관리팀, 외부서비스팀</strong>
							</div>
							<ul className="desc-group">
								<li>
									<p className="desc">Stella ERP의 모든 기능이 이용가능합니다.</p>
								</li>
								<li>
									<p className="desc">세부 기능별 권한 설정을 통해 민감 정보, 보안 관리 가능</p>
								</li>
								<li>
									<p className="desc">
										경영진과 관리팀간 체계적 커뮤니케이션 지원 <br />- 아웃소싱 최적화
									</p>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</section>
	);
};

export default ServiceBanner;
